module.exports = __webpack_public_path__ + "/images/3At-gxx.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/sticker.png
// module id = 88
// module chunks = 0